import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type ColumnHeaderProps = {
  translationKey: string;
};

export const ColumnHeader: React.FC<ColumnHeaderProps> = ({ translationKey }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  return (
    <Typography variant="body" className={styles.headerText}>
      {t(translationKey)}
    </Typography>
  );
};

const makeStyles = () => ({
  headerText: css({
    fontWeight: "bold",
  }),
});
